module.exports = __webpack_public_path__ + "static/media/squared.1f37bb78.jpg";